/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Node } from '@/client';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Alert } from '@/primitives/Alert';

export type RejectedStateAlertsProps = {
  node: Node;
};

export function RejectedStateAlerts({ node }: RejectedStateAlertsProps) {
  const { t } = useMimicTranslation('node');

  const isRejected = node.requestedRevisionState?.status === 'rejected';

  if (!isRejected) return null;

  const configChangeFailed =
    node.appliedRevisionState?.configRevision?.id !== node.requestedRevisionState?.configRevision?.id;

  const operationalStateChangeFailed =
    node.appliedRevisionState?.operationalState !== node.requestedRevisionState?.operationalState;

  return (
    <div style={{ marginTop: '8px' }}>
      {configChangeFailed && (
        <Alert
          dataTestId="config-applied-change-failed-alert"
          message={t('configAppliedChangeFailed')}
          description={t('configAppliedChangeFailedDescription', {
            configName: node.appliedRevisionState?.nodeConfig?.name || t('unknown'),
          })}
          type="error"
          showIcon
        />
      )}
      {operationalStateChangeFailed && (
        <Alert
          dataTestId="operational-state-change-failed-alert"
          message={t('operationalStateChangeFailed')}
          description={t('operationalStateChangeFailedDescription', {
            requestedState: t(node.requestedRevisionState!.operationalState),
          })}
          type="error"
          showIcon
        />
      )}
    </div>
  );
}
